import * as types from '../actions/types';
import * as request from '../utils/request';
import toastr from 'toastr';

export function getAllGroupsSuccess(groups) {
  return({
    type: types.GET_All_GROUPS_SUCCESS,
    payload: groups
  })
}

export function getGroupByIdSuccess(group) {
  return({
    type: types.GET_GROUP_BY_ID_SUCCESS,
    payload: group
  })
}



export function getAllGroups(){
  let runName = localStorage.getItem('run');
  let groups = [];

  return (dispatch) => {
    // dispatch(getAllGroupsSuccess([]));
    return new Promise(function (resolve, reject){
      function getGroups(url) {
        request.req('GET', url)
          .then(res => {
            res.data.results.forEach(course => {groups.push(course)});
            if(res.data.next == null) {
              dispatch(getAllGroupsSuccess(groups));
              return resolve();
            } else {
              getGroups(res.data.next);
            }
          }).catch(err => {
          console.log('err', err);
          return reject();
        })
      }
      getGroups('/runs/'+runName+'/groups/');
    });
  }
}

export function getGroupById(id) {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    let promise =  new Promise((resolve, reject) => {
      request.req('GET', '/runs/'+runName+'/groups/'+id+'/')
        .then(res => {
          dispatch(getGroupByIdSuccess(res.data));
          return resolve();
        }).catch(() => {
        return reject();
      });
    });
    return promise;
  }
}

export function createGroup(obj) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      let group = Object.assign({}, obj);
      if(group.budget_adjustment) {
        group.budget_adjustment = group.budget_adjustment * 100;
      }

      delete group.id;
      request.req('POST', '/runs/'+runName+'/groups/', group)
        .then(res => {
          toastr.success('Item Added Successfully.');
          return resolve(res.data);
        }).catch(err => {
        console.log('error',err);
        toastr.error('There was some error.');
        return reject();
      });
    });
    return promise;
  }
}

export function putGroup(obj) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      let group = Object.assign({}, obj);
      if(group.budget_adjustment) {
        group.budget_adjustment = group.budget_adjustment * 100;
      }

      request.req('PUT', '/runs/'+runName+'/groups/'+obj.id+'/', group)
        .then(() => {
          toastr.success('Item Changed Successfully.');
          return resolve();
        }).catch(err => {
        console.log('error',err);
        toastr.error('There was some error.');
        return reject();
      });
    });
    return promise;
  }
}


export function deleteGroup(id) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request.req('DELETE', '/runs/'+runName+'/groups/'+id+'/')
        .then(() => {
          toastr.success('Item Deleted Successfully.');
          return resolve();
        }).catch(err => {
        console.log('error',err);
        toastr.error('There was some error.');
        return reject();
      });
    });
    return promise;
  }
}


export function addStudentToGroups(studentId, groupsArray) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      let promises = groupsArray.map(group => {
        let obj = {
          student: studentId,
          group: group.id
        };
        return request.req('POST', '/runs/'+runName+'/memberships/', obj);
      });
      Promise.all(promises).then(() => {
        toastr.success('Student assigned successfully');
        return resolve();
      }).catch(err => {
        console.log('err', err);
        toastr.error('Error');
        return reject();
      });
    });
    return promise;
  }
}

export function addStudentsToGroup(groupId, studentsArray) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      let promises = studentsArray.map(student => {
        let obj = {
          group: groupId,
          student: student.id
        };
        return request.req('POST', '/runs/'+runName+'/memberships/', obj);
      });
      Promise.all(promises).then(() => {
        toastr.success('Student(s) assigned successfully');
        return resolve();
      }).catch(err => {
        console.log('err', err);
        toastr.error('Error');
        return reject();
      });
    });
    return promise;
  }
}


export function deleteMembership(id) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request.req('DELETE', '/runs/'+runName+'/memberships/'+id+'/')
          .then(() => {
          toastr.success('Removed student from group');
          return resolve();
      }).catch(err => {
        console.log('err', err);
        toastr.error('Error');
        return reject();
      });
    });
    return promise;
  }
}

export function getGroupObjById(/*id, array*/) {

}



// WEBPACK FOOTER //
// ./src/actions/groupActionCreators.js